module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/carousel_02@1x.973f02d.png";